import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postMethodForSignin } from "../../services/ApiCallMethods";

// Load from localStorage
const userFromStorage = JSON.parse(localStorage.getItem("user")) || null;
const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

// Login thunk
export const signinUser = createAsyncThunk(
  "auth/signinUser",
  async (userData, thunkAPI) => {
    try {
      const response = await postMethodForSignin("/api/auth/signin", userData);
      const data = await response.json();

      if (!response.ok) {
        const errorMessage =
          data?.message ||
          data?.error ||
          `Login failed with status ${response.status}`;
        return thunkAPI.rejectWithValue(errorMessage);
      }

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, thunkAPI) => {
    localStorage.clear();
    return true;
  }
);

const signinSlice = createSlice({
  name: "signin",
  initialState: {
    user: userFromStorage,
    loading: false,
    error: null,
    isAuthenticated: isAuthenticated,
    newLoading: false,
  },
  reducers: {
    resetSigninError: (state) => {
      state.error = null;
    },
    updateUserPassword(state) {
      if (state.user && state.user.data) {
        state.user.data.issetpassword = true;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signinUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signinUser.fulfilled, (state, action) => {
        localStorage.clear();
        const user = action.payload.user;
        const isRelatedParty = !!user?.isRelatedParty;

        const transformedUser = {
          ...user,
          isRelatedParty,
        };
        const formattedPayload = {
          data: {
            AccessToken: action.payload.token,
            message: action.payload.message,
            user: transformedUser,
          },
        };


        localStorage.setItem("user", JSON.stringify(formattedPayload));
        localStorage.setItem("isAuthenticated", "true");
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
      })
      .addCase(signinUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.loading = false;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { updateUserPassword, resetSigninError } = signinSlice.actions;
export default signinSlice.reducer;
